// Smooth scroll disabled for better performance
const SmoothScroll = ({ children }) => {
  return children;
};

export default SmoothScroll;
